import {useEffect} from 'react';
import {useSelector} from 'react-redux';

import useReconnectErrorNotification from '@/hooks/device/useReconnectErrorNotification';
import mwIotService from '@/services/mw/mwIotService';
import appRouterService from '@/services/route/appRouterService';
import {selectIsConnectingToIot, selectIsDeviceConnectedToIot} from '@/state/selectors/device';
import {selectIsDeviceConnected} from '@/state/selectors/mw';

const useDeviceDetect = () => {
    const isDeviceConnectedToIot = useSelector(selectIsDeviceConnectedToIot);
    const isConnectingToIot = useSelector(selectIsConnectingToIot);
    const isDeviceConnected = useSelector(selectIsDeviceConnected);
    const isConnectionPage = appRouterService.isConnectionPage();
    const isStartDeviceReconnect =
        !isDeviceConnectedToIot && !isConnectingToIot && isDeviceConnected && !isConnectionPage;
    const showReconnectError = useReconnectErrorNotification();

    useEffect(() => {
        if (!isStartDeviceReconnect) return;

        mwIotService.getUamDataForConnectedDevice({onError: showReconnectError});
    }, [isStartDeviceReconnect]);
};

export default useDeviceDetect;
